<div class="overlay" [class.active]="isOpen" (click)="close()"></div>
<div class="drawer" [class.open]="isOpen">
  <ng-template #drawerContent></ng-template>
</div>